// removed by extract-text-webpack-plugin
module.exports = {"baseWrap":"qempo_CollapsibleButton_baseWrap-1E68io-","collapse":"qempo_CollapsibleButton_collapse-2aOuJa6","single":"qempo_CollapsibleButton_single-jPglpak","textWrap":"qempo_CollapsibleButton_textWrap-1LkG7S4","title":"qempo_CollapsibleButton_title-C9Y3U7B","subtitle":"qempo_CollapsibleButton_subtitle-1yoQyML","content":"qempo_CollapsibleButton_content-2elPNq7","open":"qempo_CollapsibleButton_open-3KZRF1m","hrWrap":"qempo_CollapsibleButton_hrWrap-x7JGClf"};


//////////////////
// WEBPACK FOOTER
// ./src/elements/CollapsibleButton/CollapsibleButton.scss
// module id = 1337
// module chunks = 0